export function focusInput(element: HTMLElement){
  let parent = element.parentElement;
  try {
    let icon = parent?.getElementsByClassName("input-group-text")[0];
    if(icon)
    icon.classList.add("input-icon-focus");
  } catch (error) {}
}

export function focusoutInput(element: HTMLElement){
  let parent = element.parentElement;
  try {
    let icon = parent?.getElementsByClassName("input-group-text")[0];
    if(icon)
    icon.classList.remove("input-icon-focus");
  } catch (error) {}
}